export default {
    create_company_modal: {
        title: 'Создать компанию',
    },
    change_password: {
        title: 'Изменить пароль',
    },
    change_email: {
        title: 'Изменить электронную почту',
    },
    change_phone: {
        title: 'Изменить номер телефона',
    },
    verify_phone: {
        title: 'Подтвердить номер телефона',
    },
    add_credentials: {
        title: 'Добавить учетные данные',
    },
    add_password: {
        title: 'Добавить пароль',
    },
    invite_company_user: {
        title: 'Пригласить пользователя компании',
    },
    change_role_company_user: {
        title: 'Изменить роль для пользователя компании',
    },
    delete_offer: {
        title: 'Вы уверены, что хотите удалить услугу?',
    },
    delete_discount: {
        title: 'Вы уверены, что хотите удалить скидку?',
    },
    extend_offer: {
        title: 'Вы уверены, что хотите продлить услугу?',
    },
    delete_company_user: {
        title: 'Вы уверены, что хотите удалить пользователя компании?',
    },
    confirm_reservation_modal: {
        add_note: 'Добавьте заметку...',
        reservation_succeeded:
            'Поздравляем! Вы успешно забронировали. Вам будет отправлено уведомление, когда ваше бронирование будет принято.',
        reschedule_succeeded: 'Поздравляем! Вы успешно перенесли событие.',
        blocked_reservation: 'Бронирование данной услуги возможно только по телефону!',
        slot_taken: 'Слот занят! Пожалуйста, выберите другой.',
        user_blocked: 'Компания заблокировала этот аккаунт!',
        two_hours_ahead: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через два часа.',
        location: 'Местоположение',
        date_and_time: 'Дата и время',
        price: 'Цена',
        confirm_reservation: 'Пожалуйста, подтвердите ваше бронирование',
        reservation_confirmed_info: 'Спасибо. Запрос на бронирование отправлен.',
        reservation_confirmed_heading: 'Успешно забронировано!',
        reservation_confirmed_subtitle:
            'Вы можете отслеживать статус вашего бронирования в Моих бронированиях - Создано. После подтверждения или любых изменений в статусе бронирования вы будете уведомлены по электронной почте.',
        owner_reservation_confirmed_subtitle:
            'Ваше бронирование успешно создано. Спасибо, что используете Bookeraj! Наслаждайтесь своей работой.',
        mins_ahead_7200: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через пять дней.',
        mins_ahead_5760: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через четыре дня.',
        mins_ahead_4320: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через три дня.',
        mins_ahead_2880: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через два дня.',
        mins_ahead_1440: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через один день.',
        mins_ahead_240: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через четыре часа.',
        mins_ahead_180: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через три часа.',
        mins_ahead_120: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через два часа.',
        mins_ahead_90: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через полтора часа.',
        mins_ahead_60: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через один час.',
        mins_ahead_45: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 45 минут.',
        mins_ahead_30: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 30 минут.',
        mins_ahead_20: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 20 минут.',
        mins_ahead_15: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 15 минут.',
        mins_ahead_10: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 10 минут.',
        mins_ahead_5: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 5 минут.',
        mins_ahead_1: 'Этот слот нельзя резерв. Пожалуйста, выберите время, которое начинается хотя бы через 1 минуту.',
    },
    custom_reservation_modal: {
        info: 'Бесплатное бронирование позволяет забронировать услугу даже в нерабочее время, обеспечивая максимальную гибкость, дублирование и свободный выбор начала приема.',
    },
    out_of_availability_modal: {
        warning: 'Некоторые из ваших бронирований будут перенесены из-за изменения доступности',
        falling_out: `Вы уверены, что хотите изменить?`,
        offer_name: 'Услуга: {name}',
        number_rescheduled_reservations: 'Количество бронирований для переноса: {n}',
    },
    add_inactivity_modal: {
        multi_select_input: {
            label_input: 'График',
            placeholder_input: `Выберите графики`,
        },
        checkbox_label: 'Хотите установить бездействие для всех услуг, содержащих это время?',
    },
    complete_profile_modal: {
        create_company_service: 'Чтобы использовать эту опцию, вам нужно заполнить свой профиль!',
        complete_first_and_last_name: 'Чтобы использовать эту опцию, вам нужно заполнить имя и фамилию!',
        complete_mobile_phone: 'Чтобы использовать эту опцию, вам нужно заполнить мобильный телефон!',
    },
    add_inactivity: {
        title: 'Добавить бездействие',
    },
    remove_inactivity: {
        title: 'Вы уверены, что хотите удалить бездействие?',
    },
    location_used_modal: {
        title: 'Это местоположение нельзя удалить!',
        warning: 'Вы должны удалить это местоположение из следующих услуг:',
    },
    delete_location: {
        title: 'Вы уверены, что хотите удалить это местоположение?',
    },
    add_availability: {
        heading: 'Введите данные о расписании',
    },
    complete_profile: {
        heading: 'Пожалуйста, заполните свой профиль',
        description: 'Эти данные являются обязательными для бронирования услуг!',
        steps: {
            step_1: 'Имя и фамилия',
            step_2: 'Номер телефона',
        },
    },
    cookies: {
        message:
            'Наши юристы посоветовали нам сообщить вам, что мы используем файлы cookie для улучшения пользовательского опыта.',
        button: 'Принимаю файлы cookie',
    },
}
